import React, { createContext, useContext } from "react";
import { MessageChannelProvider } from "./messages/MessageChannelContext";
import { MessageContextType } from "./messages/types";
import { useMessageContextValue } from "./messages/useMessageContextValue";

const MessageContext = createContext<MessageContextType | null>(null);

const MessageStateProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const value = useMessageContextValue();

  return (
    <MessageContext.Provider value={value}>{children}</MessageContext.Provider>
  );
};

export const MessageProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => (
  <MessageChannelProvider>
    <MessageStateProvider>{children}</MessageStateProvider>
  </MessageChannelProvider>
);

export const useMessageContext = () => {
  const context = useContext(MessageContext);
  if (!context) {
    throw new Error("useMessageContext must be used within a MessageProvider");
  }
  return context;
};

export const useOptionalMessageContext = () => useContext(MessageContext);

export type { MessageContextType } from "./messages/types";
